import { render, staticRenderFns } from "./DifferentialsChart.vue?vue&type=template&id=af6b8efe&"
import script from "./DifferentialsChart.vue?vue&type=script&lang=js&"
export * from "./DifferentialsChart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports